<template>
  <q-page>
    <div class="be-main-lr row q-col-gutter-sm">
      <div class="col-md-6 offset-md-3 col-sm-12 col-xs-12">
        <div class="be-page-title q-mt-md q-mb-md" v-html="$t('contact.title')"></div>
        <q-card
          v-for="(store, index) in stores"
          :key="'store' + index"
          flat
          class="be-card"
          style="margin-bottom: 26px"
        >
          <q-card-section style="padding: 0">
            <div class="row">
              <div class="col-md-4 col-sm-12 col-xs-12" style="padding-top: 0; padding-bottom: 0">
                <div v-if="store.lat !== null && store.lng !== null">
                  <div :id="'leafletMap' + store.id" class="be-contact-map-div" />
                </div>
                <div v-else class="be-contact-map-div bg-grey-3"></div>
              </div>
              <div class="col-md-8 col-sm-12 col-xs-12 be-text-16">
                <div style="padding: 16px">
                  <div class="be-text-bold">{{ store.name }}</div>
                  <div v-if="store.address !== null" class="row q-col-gutter-sm q-mt-sm">
                    <div class="col-auto">
                      <q-icon name="app:location" class="be-icon-16" />
                    </div>
                    <div class="col">{{ store.address }}</div>
                  </div>
                  <div v-if="store.location_open_hours !== null" class="row q-col-gutter-sm q-mt-sm">
                    <div class="col-auto">
                      <q-icon name="app:events" class="be-icon-16" />
                    </div>
                    <div class="col">{{ store.location_open_hours }}</div>
                  </div>
                  <div v-if="store.phone !== null" class="row q-col-gutter-sm q-mt-sm">
                    <div class="col-auto">
                      <q-icon name="app:contact" class="be-icon-16" />
                    </div>
                    <div class="col">
                      <a :href="`tel:${store.phone}`" style="text-decoration: none; font-weight: normal">{{
                        store.phone
                      }}</a>
                    </div>
                  </div>
                  <div v-if="store.email !== null" class="row q-col-gutter-sm q-mt-sm">
                    <div class="col-auto">
                      <q-icon name="app:envelope" class="be-icon-16" />
                    </div>
                    <div class="col">
                      <a :href="`mailto:${store.email}`" style="text-decoration: none; font-weight: normal">{{
                        store.email
                      }}</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <q-btn
              icon="app:select"
              style="position: absolute; bottom: 10px; right: 10px; width: 40px; height: 40px; padding: 5px"
              class="be-icon-12 bg-accent"
              :to="`/contact/${store.url}`"
            />
          </q-card-section>
        </q-card>
      </div>
    </div>
  </q-page>
</template>

<script>
import { createMetaMixin } from 'quasar'

import { mapState } from 'pinia'
import { useSettingsStore } from 'stores/settings'

export default {
  name: 'ContactPage',
  mixins: [
    createMetaMixin(function mymeta() {
      return {
        title: `${this.$t('contact.title')} - ${this.websiteName}`,
        meta: {
          description: {
            name: 'description',
            content: `${this.$t('contact.title')} - ${this.websiteName}`
          }
        }
      }
    })
  ],
  data() {
    return {
      maps: []
    }
  },
  computed: {
    ...mapState(useSettingsStore, {
      stores: 'stores',
      websiteName: store => store.website.name
    })
  },
  beforeUnmount() {
    this.maps.forEach(map => {
      if (map !== null) {
        map.remove()
      }
    })
  },
  mounted() {
    if (typeof L !== 'undefined') {
      this.loadStoreMaps()
    } else {
      import('leaflet').then(() => {
        import('leaflet/dist/leaflet.css').then(() => {
          L.Icon.Default.imagePath = 'https://assets.boosteat.com/shop-images/leaflet/'
          this.loadStoreMaps()
        })
      })
    }
  },
  methods: {
    loadStoreMaps() {
      this.maps = []
      let i = 0
      this.stores.forEach(storeItem => {
        if (storeItem.lat !== null && storeItem.len !== null) {
          this.maps[i] = L.map(`leafletMap${storeItem.id}`).setView([Number(storeItem.lat), Number(storeItem.lng)], 15)
          L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
            attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OSM</a>'
          }).addTo(this.maps[i])
          L.marker([Number(storeItem.lat), Number(storeItem.lng)])
            .addTo(this.maps[i])
            .bindPopup(storeItem.name)
          i++
        }
      })
    }
  }
}
</script>
